import { mapSimpleCategories } from 'connectors/categories/Categories';
import { AdvertsFragmentApi, useAdvertsQueryApi } from 'graphql/generated';
import { useQueryError } from 'hooks/graphQl/UseQueryError';
import { AdvertType } from 'types/advert';

export const useAdverts = (): AdvertType[] | undefined => {
    const [{ data, error }] = useAdvertsQueryApi();
    useQueryError(error);

    if (data?.adverts === undefined) {
        return undefined;
    }

    return mapAdverts(data.adverts);
};

const mapAdverts = (apiData: AdvertsFragmentApi[]): AdvertType[] => {
    const mappedAdverts: AdvertType[] = [];

    for (const advertItem of apiData) {
        if (advertItem.__typename === 'AdvertImage') {
            mappedAdverts.push({
                __typename: 'AdvertImage',
                uuid: advertItem.uuid,
                type: advertItem.type,
                positionName: advertItem.positionName,
                name: advertItem.name,
                categories: mapSimpleCategories(advertItem.categories),
                link: advertItem.link ?? undefined,
                mainImage: advertItem.image,
                imageMobile: advertItem.imageMobile,
            });
        } else {
            mappedAdverts.push({
                __typename: 'AdvertCode',
                uuid: advertItem.uuid,
                type: advertItem.type,
                positionName: advertItem.positionName,
                name: advertItem.name,
                categories: mapSimpleCategories(advertItem.categories),
                code: advertItem.code,
            });
        }
    }

    return mappedAdverts;
};
